import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getSkinIssueTypes } from "../api/incident/apiIncidents";

export const ALL_SKIN_ISSUE_TYPES_OPTION = {
  label: "All Skin Issue Types",
  value: "all_skin_issue_types",
};

const useSkinIssueTypes = () => {
  const {
    isLoading: skinIssueTypesLoading,
    isError,
    data: skinIssueTypesData,
  } = useQuery(["skinIssueTypes"], () => getSkinIssueTypes(), {
    keepPreviousData: true,
  });

  const isLoadingOrError = skinIssueTypesLoading || isError;

  const skinIssueTypeOptions = useMemo(() => {
    if (isLoadingOrError) {
      return [ALL_SKIN_ISSUE_TYPES_OPTION];
    }

    const rawData = skinIssueTypesData?.data.data;
    if (!rawData || !Array.isArray(rawData)) {
      return [ALL_SKIN_ISSUE_TYPES_OPTION];
    }

    // Normalize different backend shapes to {label, value}
    const normalized = rawData
      .map((item: any) => {
        if (item && typeof item === "string") {
          return { label: item, value: item };
        }
        return null;
      })
      .filter(Boolean);

    // Deduplicate by value
    const unique = Array.from(
      new Map(normalized.map((option: any) => [option.value, option])).values()
    );

    return [ALL_SKIN_ISSUE_TYPES_OPTION, ...unique];
  }, [skinIssueTypesData, isLoadingOrError]);

  return {
    skinIssueTypeOptions,
    skinIssueTypesLoading,
    isError,
  };
};

export default useSkinIssueTypes;
